import { render } from "./SocialMediaShare.vue?vue&type=template&id=37e0155c&scoped=true"
import script from "./SocialMediaShare.vue?vue&type=script&lang=js"
export * from "./SocialMediaShare.vue?vue&type=script&lang=js"

import "./SocialMediaShare.vue?vue&type=style&index=0&id=37e0155c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e0155c"]])

export default __exports__